module.exports = __webpack_public_path__ + "static/media/globe-africa.a65be3bc.svg";